import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { GeneralService } from '@app/core/services/general.service';
import { AlertDialogComponent } from '@app/shared/components/alert-dialog/alert-dialog.component';
import { LoadingSpinnerComponent } from '@app/shared/components/loading-spinner/loading-spinner.component';
import { TextInputComponent } from '@app/shared/components/text-input/text-input.component';
import { customEmailValidator } from '@app/shared/validators/email-validator';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserRegistrationComponent, UserRegistrationData } from './user-registration/user-registration.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, LoadingSpinnerComponent, TextInputComponent, ReactiveFormsModule, MatButtonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;

  isCodeSent: boolean = false;

  isLoading: boolean = false;
  isScreenDesktop!: boolean;

  error: string = '';

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private authService: AuthService,
    private generalService: GeneralService,
    private dialog: MatDialog
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, customEmailValidator()]],
      code: [{ value: '', disabled: true }],
    });
  }

  ngOnInit(): void {
    this.isLoading = true;

    this.authService.autoLogin(true);

    this.authService.getApiPortalFirst().subscribe();

    this.isScreenDesktop = this.route.snapshot.data['screenSize'] == 'desktop';

    // if (!this.isScreenDesktop) {
    //   this.mobileScreenDialog();
    // }

    this.isCodeSent = false;
    this.isLoading = false;
  }

  generateCode() {
    this.isLoading = true;

    this.authService.generateLoginCode(this.loginForm.value.email).subscribe({
      next: (response: any) => {
        this.isCodeSent = true;
        this.error = '';

        this.loginForm.controls['code'].enable();
        this.loginForm.controls['code'].setValidators([Validators.required]);
        this.loginForm.controls['code'].setErrors({ incorrect: true });

        this.loginForm.controls['email'].disable();

        this.isLoading = false;
      },
      error: (error: any) => {
        this.error = error?.error?.detail || 'An error occurred';
        this.isLoading = false;
      },
    });
  }

  onSubmit() {
    if (!this.isCodeSent) {
      return this.generateCode();
    }

    const email = this.loginForm.getRawValue().email;
    const code = this.loginForm.value.code;

    this.isLoading = true;

    this.authService.login(email, code).subscribe({
      next: (response) => {
        this.isLoading = false;
      },
      error: (error) => {
        this.error = error?.error?.detail || 'An error occurred';
        this.isLoading = false;
      },
    });
  }

  onRegister() {
    const dialogRef = this.dialog.open(UserRegistrationComponent, {
      data: { email: this.loginForm.value.email },
    });

    dialogRef.afterClosed().subscribe((mutationData: UserRegistrationData) => {
      if (!mutationData) {
        return;
      }

      this.generalService.postApiUserRegistration(mutationData).subscribe({
        next: (response) => {
          this.dialog.open(AlertDialogComponent, {
            data: {
              title: 'User Registration Successful',
              message:
                'Thank you for registering with us.\n\nYou will receive an update once your registration is verified.',
            },
          });
        },
        error: (error) => {
          this.dialog.open(AlertDialogComponent, {
            data: {
              title: 'User Registration Error',
              message: error?.error?.detail || JSON.stringify(error?.error ? error?.error : error),
            },
          });
        },
        complete: () => {},
      });
    });
  }

  mobileScreenDialog() {
    this.dialog.open(AlertDialogComponent, {
      data: {
        message: 'For best experience, please visit \ncustomers.zippmat.in \non your desktop.\n',
      },
    });
  }
}
